import React, { useState, useEffect } from 'react';
import { ListItem } from '../atoms/listitem';
import { Linking, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import AntDesign from '@expo/vector-icons/AntDesign';
import ListAltTwoToneIcon from '@material-ui/icons/ListAltTwoTone';
import PersonIcon from '@material-ui/icons/Person';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import variables from '../atoms/variables.json';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import HighlightOff from '@material-ui/icons/HighlightOff';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ToolTip from '../atoms/ToolTip';
import PropertyCard from '../atoms/PropertyCard';
import DialogButton from '@material-ui/core/Button';

//import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
// import RENTAL_ICON from './../../../assets/svgIcons/OpenFlo/RentalOffer.svg';
// import { alertActions } from '_actions';
import ProgressCircle from "./components/ProgressCircle"

import { TextInput } from './../atoms/textinput';
import {
  CardWrapper,
  TlyfeSelector,
  LineSeperator,
  Heading,
  SubHeading,
  TlyfeButtonWrapper,
  ProfilesList,
  ProfilesButtonBox,
  RemoveButton,
  ViewButton,
  PersonName,
  CardFooter,
  RowContainer,
} from './style';
import { CardBox } from '../atoms/card';
import { Button } from '../atoms/button';
import { useDispatch, useSelector } from 'react-redux';
// import { tenantActions } from '_actions';
import moment from 'moment';
import BackComponent from '../atoms/backComponent';
import ToggleComplete from '../atoms/toggleComplete';
import BottomButton from '../atoms/bottomButton';
import { GetFilename, getRentalOfferStatus, GetTenancyDeposit, showErrorToast, showSuccesToast } from '../helpers';
import ContactCard from '../atoms/contactCard';
import { SpecialCondition } from '../molecules/specialCondition';
import SaveandContinueModal from '../atoms/SaveandContinueModal';
import Container from '../atoms/Container/Container';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import getPlatformType from '../../../../helpers/helpers';
import { tenantActions } from '../../redux/tenant.actions';
import { TenantService } from '../../redux/tenant.service';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import Alert from '@mui/material/Alert';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import RentalStatusTable from './RentalStatusTable';
import { useIsFocused } from '@react-navigation/native';
import DepositSchemeSelector from './components/DepositSchemeSelector';
const layoutType = getPlatformType();

const getDraftAgreementUrl = (openFlow = {}) => {
  return (
    openFlow?.draft_agreement_url ||
    openFlow?.open_flow_rental_offer?.draft_agreement_url ||
    openFlow?.ast_contract_url ||
    openFlow?.nha_contract_url ||
    openFlow?.bespoke_contract_url ||
    null
  );
};

const getTenantName = (tenant = {}) => {
  const firstName = tenant?.app_user?.user?.first_name || '';
  const lastName = tenant?.app_user?.user?.last_name || '';
  return `${firstName} ${lastName}`.trim() || '-';
};

const getDraftAgreementStatus = (tenant = {}) => {
  return tenant?.rental_offer_sent_at ? 'Sent' : 'Not Sent';
};

const getDraftAgreementSentDate = (tenant = {}) => {
  return tenant?.rental_offer_sent_at ? moment(tenant?.rental_offer_sent_at).format('DD/MM/YYYY') : '-';
};

const DraftAgreementStatusCard = ({ tenants = [], openFlow = {} }) => {
  const agreementUrl = getDraftAgreementUrl(openFlow);
  const isGenerated = Boolean(agreementUrl || openFlow?.is_ast_generated || openFlow?.is_nha_generated);
  const isPhone = layoutType === 'phone';

  const openAgreement = () => {
    if (agreementUrl) {
      if (typeof window !== 'undefined' && window.open) {
        window.open(agreementUrl, '_blank');
      } else {
        Linking.openURL(agreementUrl);
      }
    }
  };

  return (
    <View style={[draftAgreementStyles.card, isPhone && draftAgreementStyles.cardPhone]}>
      <Text style={[draftAgreementStyles.sectionTitle, isPhone && draftAgreementStyles.sectionTitlePhone]}>
        Draft Agreement Status
      </Text>

      <View style={[draftAgreementStyles.summaryCard, isPhone && draftAgreementStyles.summaryCardPhone]}>
        <Text style={draftAgreementStyles.summaryTitle}>Draft Agreement</Text>
        <View style={draftAgreementStyles.summaryActions}>
          <View
            style={[
              draftAgreementStyles.generatedChip,
              isGenerated ? draftAgreementStyles.generatedChipSuccess : draftAgreementStyles.generatedChipDefault,
            ]}
          >
            <Text
              style={[
                draftAgreementStyles.generatedChipText,
                draftAgreementStyles.generatedChipTextColor,
              ]}
            >
              {isGenerated ? 'Generated' : 'Not Generated'}
            </Text>
          </View>
          {agreementUrl ? (
            <TouchableOpacity onPress={openAgreement} style={draftAgreementStyles.viewButton}>
              <AntDesign name="eye" size={isPhone ? 22 : 24} color="#9b5de5" />
            </TouchableOpacity>
          ) : null}
        </View>
      </View>

      {isPhone ? (
        <View style={draftAgreementStyles.mobileList}>
          {tenants.map((tenant, index) => (
            <View key={tenant?.open_flow_sub_tenant_id || index} style={draftAgreementStyles.mobileRow}>
              <View style={draftAgreementStyles.mobileLine}>
                <Text style={draftAgreementStyles.mobileLabel}>Tenant</Text>
                <Text style={draftAgreementStyles.mobileValue}>{getTenantName(tenant)}</Text>
              </View>
              <View style={draftAgreementStyles.mobileLine}>
                <Text style={draftAgreementStyles.mobileLabel}>Status</Text>
                <StatusPill label={getDraftAgreementStatus(tenant)} />
              </View>
              <View style={draftAgreementStyles.mobileLine}>
                <Text style={draftAgreementStyles.mobileLabel}>Sent On</Text>
                <Text style={draftAgreementStyles.mobileValue}>{getDraftAgreementSentDate(tenant)}</Text>
              </View>
            </View>
          ))}
        </View>
      ) : (
        <View style={draftAgreementStyles.table}>
          <View style={[draftAgreementStyles.tableRow, draftAgreementStyles.tableHeader]}>
            <View style={draftAgreementStyles.tenantCell}>
              <Text style={draftAgreementStyles.headerText}>TENANT</Text>
            </View>
            <View style={draftAgreementStyles.statusCell}>
              <Text style={[draftAgreementStyles.headerText, draftAgreementStyles.centerText]}>STATUS</Text>
            </View>
            <View style={draftAgreementStyles.sentCell}>
              <Text style={[draftAgreementStyles.headerText, draftAgreementStyles.rightText]}>SENT ON</Text>
            </View>
          </View>
          {tenants.map((tenant, index) => (
            <View key={tenant?.open_flow_sub_tenant_id || index} style={draftAgreementStyles.tableRow}>
              <View style={draftAgreementStyles.tenantCell}>
                <Text style={draftAgreementStyles.cellText}>{getTenantName(tenant)}</Text>
              </View>
              <View style={[draftAgreementStyles.statusCell, draftAgreementStyles.centerCell]}>
                <StatusPill label={getDraftAgreementStatus(tenant)} />
              </View>
              <View style={[draftAgreementStyles.sentCell, draftAgreementStyles.rightCell]}>
                <Text style={draftAgreementStyles.cellText}>{getDraftAgreementSentDate(tenant)}</Text>
              </View>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

const StatusPill = ({ label }) => {
  const isSent = label === 'Sent';

  return (
    <View
      style={[
        draftAgreementStyles.statusPill,
        isSent ? draftAgreementStyles.statusPillSent : draftAgreementStyles.statusPillNotSent,
      ]}
    >
      <Text
        style={[
          draftAgreementStyles.statusPillText,
          isSent ? draftAgreementStyles.statusPillTextSent : draftAgreementStyles.statusPillTextNotSent,
        ]}
      >
        {label}
      </Text>
    </View>
  );
};

const draftAgreementStyles = StyleSheet.create({
  card: {
    backgroundColor: '#FFFFFF',
    borderColor: '#E4EAF5',
    borderRadius: 12,
    borderWidth: 1,
    marginTop: 10,
    padding: 16,
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.06,
    shadowRadius: 10,
    elevation: 2,
  },
  cardPhone: {
    padding: 14,
  },
  sectionTitle: {
    alignSelf: 'flex-start',
    color: '#3f51b5',
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 14,
  },
  sectionTitlePhone: {
    fontSize: 16,
    marginBottom: 12,
  },
  summaryCard: {
    alignItems: 'center',
    backgroundColor: '#FBFCFF',
    borderColor: '#EEF2F7',
    borderRadius: 10,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 18,
    paddingHorizontal: 18,
    paddingVertical: 16,
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 6,
    elevation: 1,
  },
  summaryCardPhone: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    marginBottom: 20,
    paddingHorizontal: 16,
    paddingVertical: 18,
  },
  summaryTitle: {
    color: '#6B7280',
    fontSize: 15,
    fontWeight: '600',
  },
  summaryActions: {
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: layoutType === 'phone' ? 14 : 0,
  },
  generatedChip: {
    borderRadius: 14,
    paddingHorizontal: 10,
    paddingVertical: 4,
  },
  generatedChipSuccess: {
    backgroundColor: variables.peachgreen,
  },
  generatedChipDefault: {
    backgroundColor: variables.lightgrey,
  },
  generatedChipText: {
    fontSize: 13,
    fontWeight: '700',
  },
  generatedChipTextColor: {
    color: variables.black,
  },
  viewButton: {
    marginLeft: 14,
    padding: 4,
  },
  table: {
    width: '100%',
  },
  tableRow: {
    borderBottomColor: '#EAECF0',
    borderBottomWidth: 1,
    flexDirection: 'row',
    minHeight: 56,
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
    minHeight: 46,
  },
  tenantCell: {
    flex: 1.2,
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  statusCell: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  sentCell: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  centerCell: {
    alignItems: 'center',
  },
  rightCell: {
    alignItems: 'flex-end',
  },
  centerText: {
    textAlign: 'center',
  },
  rightText: {
    textAlign: 'right',
  },
  headerText: {
    color: '#707085',
    fontSize: 14,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  cellText: {
    color: '#707085',
    fontSize: 15,
    fontWeight: '500',
  },
  statusPill: {
    alignSelf: 'center',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 5,
  },
  statusPillSent: {
    backgroundColor: variables.yellow,
  },
  statusPillNotSent: {
    backgroundColor: variables.lightgrey,
  },
  statusPillText: {
    fontSize: 14,
    fontWeight: '500',
  },
  statusPillTextSent: {
    color: variables.black,
  },
  statusPillTextNotSent: {
    color: variables.black,
  },
  mobileList: {
    borderTopColor: '#EAECF0',
    borderTopWidth: 1,
  },
  mobileRow: {
    borderBottomColor: '#EAECF0',
    borderBottomWidth: 1,
    paddingVertical: 14,
  },
  mobileLine: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
  },
  mobileLabel: {
    color: '#707085',
    fontSize: 13,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  mobileValue: {
    color: '#707085',
    flex: 1,
    fontSize: 15,
    fontWeight: '500',
    marginLeft: 16,
    textAlign: 'right',
  },
});

const RentalOffers = (props) => {
  const dispatch = useDispatch();
  const [days, setDays] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  ]);
  const rental_offers_data = useSelector((state) => state?.tenant?.flowIdInfo?.open_flow_rental_offer);
  const global_state = useSelector((state) => state?.tenant?.flowIdInfo);

  const tenants = useSelector((state) => state?.tenant?.flowIdInfo?.tenants);
  const tdsData = useSelector((state) => state?.tenant?.tdsData);
  const [isValidated, setIsValidated] = React.useState(false);

  const [selectedTds, setSelectedTds] = React.useState();

  useEffect(() => {
    dispatch(tenantActions.getTdsData());
    dispatch(tenantActions.getCommonClauses());
  }, []);

  const [tdsArry, setTdsArray] = React.useState([]);
  const loading = useSelector((state) => state?.tenant?.tenantLoading);
  console.log("tdsArry", tdsArry)
  const caclDateDiff = (date1, date2) => {
    if (date1 && date2) {
      if (moment(date1).format('YYYY-MM-DD') === moment(date2).format('YYYY-MM-DD')) {
        return 'No';
      } else {
        return 'Yes';
      }
    } else {
      return 'No';
    }
  };
  var intialValues = {
    rental_amount: rental_offers_data ? rental_offers_data?.rental_amount : '',

    isComplete: '',
    draft_agreement_type: global_state?.draft_agreement_type ? global_state.draft_agreement_type : 'ast',
    is_Initial_Rental_Payment:
      rental_offers_data?.is_irp_required === true
        ? 'Yes'
        : rental_offers_data?.is_irp_required === false
          ? 'No'
          : 'Yes',
    rental_due_date: rental_offers_data ? rental_offers_data?.rental_due_date : '',
    furnished_type: rental_offers_data?.furnished ? rental_offers_data?.furnished : 'Furnished',
    rental_payments_recipient: global_state?.is_rental_payment_received_by_landlord ? "Landlord" : "Agent",
    rental_frequency: rental_offers_data?.rental_frequency
      ? rental_offers_data?.rental_frequency
      : 'monthly',
    initial_rental_amount: rental_offers_data?.initial_rental_amount
      ? rental_offers_data?.initial_rental_amount
      : rental_offers_data?.rental_amount
        ? rental_offers_data?.rental_amount
        : '',
    deposit: rental_offers_data ? rental_offers_data?.tenancy_deposit : '',
    move_in_date: rental_offers_data
      ? moment(rental_offers_data?.move_in_date).format('YYYY-MM-DD')
      : '',
    tenancy_start_date: rental_offers_data
      ? moment(rental_offers_data?.tenancy_start_date).format('YYYY-MM-DD')
      : '',
    tenancy_end_date: rental_offers_data
      ? moment(rental_offers_data?.tenancy_end_date).format('YYYY-MM-DD')
      : '',

    irp_start_date: rental_offers_data
      ? moment(rental_offers_data?.irp_start_date).format('YYYY-MM-DD')
      : '',

    irp_end_date: rental_offers_data?.irp_end_date
      ? moment(rental_offers_data?.irp_end_date).format('YYYY-MM-DD')
      : moment(rental_offers_data?.irp_start_date).add(1, 'M').subtract(1, 'days').format('YYYY-MM-DD'),

    is_date_different: caclDateDiff(
      rental_offers_data?.tenancy_start_date,
      rental_offers_data?.move_in_date
    ),
    broadband: rental_offers_data?.tenant_broadbank_phone_responsibility ? rental_offers_data?.tenant_broadbank_phone_responsibility : false,
    tv_license: rental_offers_data?.tenant_tv_license_responsibility ? rental_offers_data?.tenant_tv_license_responsibility : false,
    council_tax: rental_offers_data?.tenant_council_tax_responsibility ? rental_offers_data?.tenant_council_tax_responsibility : false,
    water: rental_offers_data?.tenant_water_responsibility ? rental_offers_data?.tenant_water_responsibility : false,
    electricity: rental_offers_data?.tenant_electricity_responsibility ? rental_offers_data?.tenant_electricity_responsibility : false,
    gas: rental_offers_data?.tenant_gas_responsibility ? rental_offers_data?.tenant_gas_responsibility : false,
    tenants: tenants?.length ? tenants : [],
    tenancy_deposit: rental_offers_data?.tenancy_deposit_amount,
    number_of_occupants: global_state?.number_of_occupants ? global_state?.number_of_occupants : '',
  };
  const [flowId, setFlowId] = React.useState(null);
  const [offerStatus, setOfferStatus] = React.useState(0);
  const [teanats, setTeanats] = React.useState([]);
  const [commonCondition, setCommonCondition] = useState([]);
  const [commonConditionObj, setCommonConditionObj] = useState({});

  const [isModified, setIsModified] = useState(false);
  const [commonConditionText, setCommonConditionText] = useState('');
  const [additionalCondition, setAdditionalCondition] = useState([]);
  const [additionalConditionText, setAdditionalConditionText] = useState('');
  const [break_clause, setBreakClause] = useState('');
  const [additionalError, setAdditionalError] = React.useState(false);
  const [commonConditionError, setCommonConditionError] = React.useState(false);
  const [dayStart, setDayStart] = useState(1);
  const [fieldsValue, setFieldValues] = useState(intialValues);
  const [showSuccessModal, setSuccessModal] = React.useState(false);
  const modalGlobalObject = useSelector((state) => state?.tenant?.rentalOffersData);
  const [modalState, setModalState] = React.useState({
    send_to_tenant: true,
  });
  useEffect(() => {
    if (modalGlobalObject) {
      setModalState({
        send_to_tenant: modalGlobalObject.send_to_tenant,
      });
    }
  }, [modalGlobalObject]);

  useEffect(() => {
    if (tdsData) {
      setTdsArray(tdsData);
    }
  }, [tdsData]);
  useEffect(() => {
    if (fieldsValue?.tenancy_end_date === 'Invalid date' && fieldsValue?.tenancy_start_date !== 'YYYY-MM-DD') {
      setFieldValues({
        ...fieldsValue,
        irp_start_date: moment(fieldsValue.move_in_date).add(1, 'month').format('YYYY-MM-DD'),
        irp_end_date: moment(fieldsValue.tenancy_start_date).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD'),
        tenancy_end_date: moment(fieldsValue.tenancy_start_date).add(1, 'years').subtract(1, 'd').format('YYYY-MM-DD'),
      });
    }
  }, [fieldsValue?.tenancy_start_date]);
  const focused = useIsFocused();
  useEffect(() => {
    if (props?.route?.params?.id) {
      setFlowId(props?.route?.params?.id);
      fetchData()
    }
  }, [props?.route?.params?.id, focused]);
  const fetchData = () => {
    dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
  }
  useEffect(() => {
    if (rental_offers_data) {
      setFieldValues(intialValues);
    } else {
      setFieldValues(intialValues)
    }
  }, [
    rental_offers_data,
    rental_offers_data?.open_flow_rental_offer_id,
    focused
  ]);

  useEffect(() => {
    if (global_state?.draft_agreement_type) {
      setFieldValues(prev => ({
        ...prev,
        draft_agreement_type: global_state.draft_agreement_type,
      }));
    }
  }, [global_state?.draft_agreement_type]);

  const [showUpdateRentalOfferModal, setShowUpdateRentalOfferModal] = useState(false);


  useEffect(() => {
    if (teanats.length) {
      const tenants1 = teanats.filter((tenant) => tenant?.rental_offer_status == 0);
      console.log("tenants1", tenants1)
      setShowUpdateRentalOfferModal(tenants1.length !== teanats.length)
    } else {
      setShowUpdateRentalOfferModal(false)
    }

  }, [teanats, rental_offers_data,]);


  useEffect(() => {
    console.log("initialSelectedId global_state", global_state?.open_flow_move_in?.open_flow_tenancy_document_scheme_id)
    setSelectedTds(global_state?.open_flow_move_in?.open_flow_tenancy_document_scheme_id);
  }, [global_state?.open_flow_move_in?.open_flow_tenancy_document_scheme_id]);
  console.log("initialSelectedId global_state 2", selectedTds)

  useEffect(() => {
    let rental_offer_status = 0;
    if (tenants?.length) {
      setTeanats(tenants);

      let ar = tenants;
      ar.some(function (item, index) {
        if (item?.rental_offer_status > 0) {
          rental_offer_status = item?.rental_offer_status;
          return true;
        }
      });
      setOfferStatus(rental_offer_status);
    }
  }, [rental_offers_data, tenants]);

  useEffect(() => {
    if (rental_offers_data?.break_clause) {
      setBreakClause(rental_offers_data?.break_clause);
    }
    if (rental_offers_data?.common_conditions) {
      setCommonCondition(JSON.parse(rental_offers_data?.common_conditions));
    }
    if (rental_offers_data?.additional_conditions) {
      setAdditionalCondition(rental_offers_data?.additional_conditions.split(',').map(c => c.replace(/，/g, ',')));
    }
  }, [rental_offers_data]);

  const handleChange = (e, name) => {

    if (!isModified) {
      setIsModified(true);
    }
    if ([e.target.name] == 'initial_rental_amount') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value.replace(/[^0-9.]/g, ''),
      });
    }
    if ([e.target.name] == 'rental_amount') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value.replace(/[^0-9.]/g, ''),
        initial_rental_amount: e.target.value.replace(/[^0-9.]/g, ''),
        tenancy_deposit: GetTenancyDeposit(e.target.value.replace(/[^0-9.]/g, ''), fieldsValue?.rental_frequency),
      });
    }
    if ([e.target.name] == 'move_in_date') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value,
        irp_start_date: moment(e.target.value).add(1, 'month').format('YYYY-MM-DD'),
      });
    }

    if ([e.target.name] == 'rental_frequency') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value,
        tenancy_deposit: GetTenancyDeposit(fieldsValue.rental_amount, e.target.value),
      });
    }
    if ([e.target.name] == 'draft_agreement_type') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value,
      });
    }
    if ([e.target.name] == 'tenancy_start_date') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value,
        irp_start_date: e.target.value,
        irp_end_date: moment(e.target.value).add(1, 'M').subtract(1, 'days').format('YYYY-MM-DD'),
        tenancy_end_date: moment(e.target.value).add(1, 'years').subtract(1, 'd').format('YYYY-MM-DD'),
      });
    }
    if ([e.target.name] == 'is_Initial_Rental_Payment') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value,
        initial_rental_amount: fieldsValue?.initial_rental_amount
          ? fieldsValue?.initial_rental_amount
          : rental_offers_data?.conditions?.rental_amount,
      });
    }
    if ([e.target.name] == 'irp_start_date') {
      return setFieldValues({
        ...fieldsValue,
        [e.target.name]: e.target.value,
        irp_start_date: e.target.value,
        irp_end_date: moment(e.target.value).add(1, 'M').subtract(1, 'days').format('YYYY-MM-DD'),
      });
    }

    setFieldValues({
      ...fieldsValue,
      [e.target.name]: e.target.value ? e.target.value : name,
    });
  };


  const _onAddRentalData = (url, data) => {
    setIsValidated(true);
    console.log("selectedTds", selectedTds)
    let payload2 = {
      "flow_id": parseFloat(flowId),
      "number_of_occupants": fieldsValue?.number_of_occupants ? parseFloat(fieldsValue?.number_of_occupants) : 0,
      "rental_amount": parseFloat(fieldsValue?.rental_amount),
      "tenancy_end_date": fieldsValue?.tenancy_end_date,
      "tenancy_start_date": fieldsValue?.tenancy_start_date,
      "rental_due_date": fieldsValue?.rental_due_date,
      "open_flow_tenancy_document_scheme_id": selectedTds,
      "rental_frequency": fieldsValue?.rental_frequency,
      "is_irp_required": fieldsValue?.is_Initial_Rental_Payment == 'Yes',
      "tenancy_deposit_amount": parseFloat(fieldsValue?.tenancy_deposit),
      "additional_conditions": additionalCondition.map(c => c.replace(/,/g, '，')).join(','),
      "furnished": fieldsValue?.furnished_type,
      "draft_agreement_type": fieldsValue?.draft_agreement_type || 'ast',
      "common_conditions": JSON.stringify(commonCondition),
      "tenant_gas_responsibility": fieldsValue?.gas,
      "irp_end_date": fieldsValue?.irp_end_date,
      "tenant_water_responsibility": fieldsValue?.water,
      "irp_start_date": fieldsValue?.irp_start_date,
      "tenant_tv_license_responsibility": fieldsValue?.tv_license,
      "tenant_electricity_responsibility": fieldsValue?.electricity,
      "tenant_council_tax_responsibility": fieldsValue?.council_tax,
      "is_rental_payment_received_by_landlord": true,
      "initial_rental_amount": parseFloat(fieldsValue?.initial_rental_amount),
      "tenant_broadbank_phone_responsibility": fieldsValue?.broadband,
      "movein_date": fieldsValue.is_date_different == 'Yes' ? fieldsValue?.move_in_date : fieldsValue?.tenancy_start_date,
    }

    if (
      (fieldsValue?.rental_amount &&
        selectedTds &&
        fieldsValue?.is_Initial_Rental_Payment == 'Yes' &&
        fieldsValue?.initial_rental_amount) ||
      (fieldsValue?.rental_amount && fieldsValue?.is_Initial_Rental_Payment == 'No')
    ) {
      dispatch(tenantActions.addRentalOffer(payload2, flowId, url));
    } else if (!selectedTds) {
      showErrorToast('Please select TDS scheme!')
    } else {
      window.scrollTo({ top: 400, behavior: 'smooth' });
      showErrorToast('Please select all mandatory fields')
    }
  };

  const _addCommonCondition = (obj) => {
    if (obj) {
      let _array = [...commonCondition];
      setCommonCondition([..._array, obj]);
      setCommonConditionObj({});
    }
  };

  const _subCommonCondition = (value) => {
    let _array = [...commonCondition];
    const finalArray = _array.filter((val) => {
      if (val !== value) return val;
    });
    setCommonCondition(finalArray);
  };

  const _subAdditionCondition = (value) => {
    let _array = [...additionalCondition];
    const finalArray = _array.filter((val) => {
      if (val !== value) return val;
    });
    setAdditionalCondition(finalArray);
  };
  const renderModalBody = (data) => {
    console.log("renderModalBody", data)
    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        {data?.opbrix_id && (
          <TextInput
            title={
              <>
                <strong>TLyfeId: </strong>
              </>
            }
            type={'row'}
            wrapperstyle={{
              width: '99%',
              marginTop: 20,
            }}
            containerstyles={{ width: '100%' }}
            value={data?.opbrix_id || ''}
          />
        )}
        <TextInput
          title={
            <>
              <strong>Title: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '10%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.title || ''}
        />
        <TextInput
          title={
            <>
              <strong>First Name: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '38%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.first_name || ''}
        />
        <TextInput
          title={
            <>
              <strong>Last Name: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.last_name || ''}
        />
        <TextInput
          title={
            <>
              <strong>Email: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.email || ''}
        />
        <TextInput
          title={
            <>
              <strong>Contact Number: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.contact_number || ''}
        />
        <TextInput
          title={
            <>
              <strong>Post Code: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.postcode || ''}
        />
        <TextInput
          title={
            <>
              <strong>Address: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.address || ''}
        />
      </div>
    )
  }
  const _addAdditionCondition = (text) => {
    if (text) {
      let _array = [...additionalCondition];
      setAdditionalCondition([..._array, text]);
      setAdditionalConditionText('');
    } else {
      setAdditionalError(true);
    }
  };
  const draftAgreementOptions = [
    { value: 'ast', label: 'Assured Periodic Tenancy' },
    { value: 'nha', label: 'Non-Housing Act (NHA)' },
  ];

  return (
    <Container style={{ fontWeight: 400 }}>

      <CardWrapper>
        <ProgressCircle props={props} />
        <BackComponent
          id={flowId}
          isComplete={global_state?.rental_offer_status === 1 ? true : false}
          flowtype="rental_offer_status"
        />

        <Card style={{ marginTop: 18, border: '1px solid #E4EAF5', borderRadius: 16, boxShadow: '0 12px 28px rgba(21, 49, 102, 0.06)' }}>
          <CardHeader
            title={
              <Typography variant='subtitle1' style={{ color: variables.purple, fontWeight: 700 }}>
                Draft Agreement
              </Typography>
            }
          />
          <CardContent style={{ paddingTop: 0 }}>
            <Alert severity='info' style={{ marginBottom: 16 }}>
              A draft agreement with a full statement of terms will be selected before saving the rental offer.
            </Alert>
            <Typography variant='body2' style={{ marginBottom: 10, fontWeight: 600, color: '#475467' }}>
              Which type of draft agreement do you wish to send?
            </Typography>
            {console.log("DEBUG draft_agreement_type =>", "global_state:", global_state?.draft_agreement_type, "| fieldsValue:", fieldsValue?.draft_agreement_type)}
            <FormControl component="fieldset">
              <RadioGroup
                row
                key={global_state?.draft_agreement_type || 'ast'}
                name="draft_agreement_type"
                value={fieldsValue?.draft_agreement_type || global_state?.draft_agreement_type || 'ast'}
                onChange={handleChange}
              >
                {draftAgreementOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    control={<Radio style={{ color: variables.heliotrope }} />}
                    label={option.label}
                    style={{ color: '#111827' }}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </CardContent>
        </Card>

        {/* <ProfilesList>
          {fieldsValue.tenants &&
            fieldsValue.tenants.map((item) => (
              <ContactCard
                key={item?.app_user?.user?.email + new Date()}
                nonRemove
                data={{
                  opbrix_id: item?.app_user?.opbrix_id,
                  title: item?.app_user?.user?.title,
                  first_name: item?.app_user?.user?.first_name,
                  last_name: item?.app_user?.user?.last_name,
                  email: item?.app_user?.user?.email,
                  number: item?.app_user?.user?.contact_number,
                  post_code: item?.app_user?.user?.postcode,
                  address: item?.app_user?.user?.address,
                  tenant_id: item?.app_user?.opbrix_id,
                }}
                row={item?.app_user?.user?.email}
                is_lead={item?.is_lead ? true : false}
                name={item?.app_user?.user?.first_name + ' ' + item?.app_user?.user?.last_name}
                renderModal={renderModalBody(item)}
              />
            ))}
        </ProfilesList> */}
        <TlyfeSelector style={{ marginTop: 30, justifyContent: 'space-between' }}>
          <div
            style={{
              flex: 0.5,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Heading style={{ color: variables.purple }}>Condition of Offer</Heading>
          </div>
        </TlyfeSelector>
        <View style={{ position: 'relative' }}>
          <ToolTip
            style={{ bottom: '40%', right: '-29%' }}
            heading={'Move in Date'}
            ContentData={[`Under some circumstances the "move-in" date may be after the actual tenancy start date.`]}
          />

          <ToolTip
            style={{ bottom: '0%', right: '-29%' }}
            heading={'Initial Rental Period = UPFRONT PAYMENT'}
            ContentData={[
              'This is the period that covers the upfront rental amount.',
              'I.e 1 months rent in advance etc',
            ]}
          />
          <CardBox
            hasShadow={true}
            hasBorderRadius={true}
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              marginBottom: 30,
              padding: 24,
              border: '1px solid #E4EAF5',
              backgroundColor: '#FFFFFF',
            }}
          >

            <TextInput
              title={'Rental amount (£)'}
              isfullwidth={true}
              error={isModified && !fieldsValue.rental_amount ? true : false}
              value={fieldsValue.rental_amount || ''}
              wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%', marginBottom: 15 }}
              onChange={handleChange}
              name="rental_amount"
              error={fieldsValue.rental_amount ? false : isValidated ? true : false}
            />
            <div
              style={{
                display: 'flex',
                width: layoutType == 'phone' ? '100%' : '49%',
                alignItems: 'center',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
              }}
            >
              <SubHeading style={{ fontSize: 14, width: '100%' }}>Frequency</SubHeading>

              <Select
                value={fieldsValue?.rental_frequency}
                className="form-control"
                onChange={handleChange}
                style={{ width: '100%', height: 42, marginTop: 7 }}
                variant="outlined"
                name="rental_frequency"
                placeholder="duration"
              >
                <MenuItem value={'week'}>Weekly</MenuItem>
                <MenuItem value={'monthly'}>Per Calender Month</MenuItem>
                <MenuItem value={'quarterly'}>Quarterly</MenuItem>
                <MenuItem value={'6 monthly'}>6 Monthly</MenuItem>
                <MenuItem value={'annually'}>Annually</MenuItem>
              </Select>
            </div>

            <div
              style={{
                display: 'flex',
                width: layoutType == 'phone' ? '100%' : '49%',
                alignItems: 'center',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
              }}
            >
              <SubHeading style={{ fontSize: 14, width: '100%' }}>Rent Due Date</SubHeading>
              <Select
                value={fieldsValue?.rental_due_date || ''}
                style={{ width: '100%', height: '42px', marginTop: 8, borderWidth: 0 }}
                onChange={handleChange}
                variant="outlined"
                name="rental_due_date"
                placeholder="duration"
              >
                {days.map((ele, index) => {
                  return (
                    <MenuItem key={index} value={ele}>
                      {ele}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
            <TextInput
              title={'Tenancy Deposit'}
              isfullwidth={true}
              wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%', marginBottom: 0 }}
              value={fieldsValue?.tenancy_deposit}
              // value={fieldsValue?.rental_amount ? GetTenancyDeposit(fieldsValue?.rental_amount, fieldsValue?.rental_frequency): 0}
              onChange={handleChange}
              name="tenancy_deposit"
            />


            <React.Fragment>


              <TextInput
                title={'Tenancy start date'}
                isfullwidth={true}
                type={'date'}
                value={fieldsValue.tenancy_start_date || ''}
                inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }}
                wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%', marginBottom: 15 }}
                onChange={handleChange}
                error={isModified && !fieldsValue.tenancy_start_date ? true : false}
                name="tenancy_start_date"
                formatDate={(date) => {
                  console.log('datedate', date);
                  moment(date).format('DD-MM-YYYY');
                }}
              />
              <TextInput
                title={fieldsValue?.draft_agreement_type?.toLowerCase() === 'ast' || global_state?.draft_agreement_type?.toLowerCase() === 'ast' ? 'Expected Rent Review Date' : 'Tenancy End date'}
                type={'date'}
                isfullwidth={true}
                value={fieldsValue.tenancy_end_date || ''}
                inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }}
                error={isModified && !fieldsValue.tenancy_end_date ? true : false}
                wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%', marginBottom: 15 }}
                onChange={handleChange}
                name="tenancy_end_date"
              />
            </React.Fragment>
            <TlyfeSelector style={{ width: '100%', marginTop: 10 }}>
              <div
                style={{
                  flex: 0.7,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingRight: 10,
                }}
              >
                <SubHeading style={{ fontWeight: '900' }}>
                  Is the "Move in" date different from "Tenancy Start" date?
                </SubHeading>
              </div>
              <div
                style={{
                  flex: 0.3,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="is_date_different"
                    name="is_date_different"
                    value={fieldsValue.is_date_different || false}
                    onChange={handleChange}
                    name="is_date_different"
                  >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <FormControlLabel
                        value="Yes"
                        control={<Radio style={{ color: variables.heliotrope }} />}
                        style={{ color: 'black' }}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio style={{ color: variables.heliotrope }} />}
                        style={{ color: 'black' }}
                        label="No"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </TlyfeSelector>
            <TextInput
              title={'Move in Date'}
              isfullwidth={false}
              type={'date'}
              disabled={fieldsValue.is_date_different !== 'Yes'}
              wrapperstyle={{ width: '100%', marginBottom: 15 }}
              containerstyles={{ width: layoutType == 'phone' ? '100%' : '49%' }}
              onChange={handleChange}
              inputProps={{ min: fieldsValue.tenancy_start_date }}
              error={isModified && !fieldsValue.move_in_date ? true : false}
              value={
                fieldsValue.is_date_different === 'Yes' ? fieldsValue.move_in_date : fieldsValue.tenancy_start_date
              }
              name="move_in_date"
            />
            <TlyfeSelector style={{ width: '100%', marginTop: 10 }}>
              <div
                style={{
                  flex: 0.7,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <SubHeading>Is an Initial Rental Payment (IRP) (£) required?</SubHeading>
              </div>
              <div
                style={{
                  flex: 0.3,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="is_Initial_Rental_Payment"
                    name="is_Initial_Rental_Payment"
                    value={fieldsValue?.is_Initial_Rental_Payment || false}
                    onChange={handleChange}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <FormControlLabel
                        value="Yes"
                        control={<Radio style={{ color: variables.heliotrope }} />}
                        style={{ color: 'black' }}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio style={{ color: variables.heliotrope }} />}
                        style={{ color: 'black' }}
                        label="No"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </TlyfeSelector>
            {fieldsValue?.is_Initial_Rental_Payment == 'Yes' && (
              <>
                <TextInput
                  title={'Initial Rental Payment (IRP) (£)'}
                  isfullwidth={true}
                  error={isModified && !fieldsValue.initial_rental_amount ? true : false}
                  value={fieldsValue.initial_rental_amount || ''}
                  wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%' }}
                  onChange={handleChange}
                  name="initial_rental_amount"
                  error={fieldsValue.initial_rental_amount ? false : isValidated ? true : false}
                />
                <SubHeading style={{ fontSize: 14, width: '100%', marginTop: 20 }}>
                  Initial Rental Period (Covered by IRP)
                </SubHeading>

                <React.Fragment>
                  <TextInput
                    title={'Start Date'}
                    isfullwidth={true}
                    type={'date'}
                    inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }}
                    error={isModified && !fieldsValue.irp_start_date ? true : false}
                    wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%', marginBottom: 15 }}
                    onChange={handleChange}
                    value={fieldsValue.irp_start_date || ''}
                    name="irp_start_date"
                  />
                  <TextInput
                    title={'End Date'}
                    type={'date'}
                    isfullwidth={true}
                    wrapperstyle={{
                      width: layoutType == 'phone' ? '100%' : '49%',
                      marginBottom: 15,
                      marginLeft: '2%',
                    }}
                    inputProps={{
                      min: moment(fieldsValue?.irp_start_date).add(1, 'M').subtract(1, 'days').format('YYYY-MM-DD'),
                    }}
                    error={isModified && !fieldsValue.irp_end_date ? true : false}
                    onChange={handleChange}
                    value={fieldsValue.irp_end_date || ''}
                    name="irp_end_date"
                  />
                </React.Fragment>
              </>
            )}
          </CardBox>
        </View>
        <SpecialCondition
          commonCondition={commonCondition}
          additionalCondition={additionalCondition}
          break_clause={break_clause}
          setBreakClause={setBreakClause}
          _subAdditionCondition={_subAdditionCondition}
          _subCommonCondition={_subCommonCondition}
          commonConditionText={commonConditionText}
          setCommonConditionText={setCommonConditionText}
          _addCommonCondition={_addCommonCondition}
          additionalConditionText={additionalConditionText}
          setAdditionalConditionText={setAdditionalConditionText}
          _addAdditionCondition={_addAdditionCondition}
          _subAdditionCondition={_subAdditionCondition}
        />
        <Heading style={{ color: variables.purple, marginTop: '4%' }}>Tenant Responsibilities</Heading>

        <CardBox hasShadow={true} hasBorderRadius={true} style={{ position: 'relative', width: '100%', padding: 24, border: '1px solid #E4EAF5', backgroundColor: '#FFFFFF' }}>
          <SubHeading style={{ marginTop: 0, marginBottom: 18 }}>Select items are the tenant’s responsibility</SubHeading>
          <FormControl
            component="fieldset"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              width: '100%',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  name="gas"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.gas || false}
                  onChange={(e) => handleChange(e, !fieldsValue.gas)}
                />
              }
              label="Gas"
              style={{ width: layoutType === 'phone' ? '100%' : '32%', color: '#000', fontSize: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="electricity"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.electricity || false}
                  onChange={(e) => handleChange(e, !fieldsValue.electricity)}
                />
              }
              style={{ width: layoutType === 'phone' ? '100%' : '32%', color: '#000', fontSize: 10 }}
              label="Electricity"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="water"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.water || false}
                  onChange={(e) => handleChange(e, !fieldsValue.water)}
                />
              }
              label="Water"
              style={{ width: layoutType === 'phone' ? '100%' : '32%', color: '#000', fontSize: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="council_tax"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.council_tax || false}
                  onChange={(e) => handleChange(e, !fieldsValue.council_tax)}
                />
              }
              label="Council Tax"
              style={{ width: layoutType === 'phone' ? '100%' : '32%', color: '#000', fontSize: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="tv_license"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.tv_license || false}
                  onChange={(e) => handleChange(e, !fieldsValue.tv_license)}
                />
              }
              style={{ width: layoutType === 'phone' ? '100%' : '32%', color: '#000', fontSize: 10 }}
              label="TV License"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="broadband"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.broadband || false}
                  onChange={(e) => handleChange(e, !fieldsValue.broadband)}
                />
              }
              label="Broadband/phone"
              style={{ width: layoutType === 'phone' ? '100%' : '32%', color: '#000', fontSize: 10 }}
            />
          </FormControl>
          <ToolTip
            style={{ bottom: '-234%', right: '-29%' }}
            heading={'Special Conditions'}
            ContentData={[
              'Common clauses are clauses that are often used and have been pre-drafted for ease of use.',
              'Select as many as you require.',
              'Additional clauses agreed between both parties may be selected; this is for you to manually add. Please speak to your legal team to ensure the wording is correct',
            ]}
          />{' '}
        </CardBox>
        {/* <Heading style={{ color: variables.purple, marginTop: '4%' }}>Future Rental Payments</Heading> */}

        {/* <CardBox hasShadow={true} hasBorderRadius={true} style={{ width: '100%' }}>
          <SubHeading style={{ marginTop: 0 }}>Who will collect future rental Payment</SubHeading>
          <Select
            value={fieldsValue?.rental_payments_recipient}
            style={{ width: '50%', height: '40px', borderWidth: 0 }}
            onChange={handleChange}
            variant="outlined"
            name="rental_payments_recipient"
            placeholder="rental_payments_recipient"
          >
            <MenuItem value={'Agent'}>Agent</MenuItem>
            <MenuItem value={'Landlord'}>Landlord</MenuItem>
          </Select>
        </CardBox> */}
        <Heading style={{ color: variables.purple, marginTop: '4%' }}>Furnishing</Heading>

        <CardBox hasShadow={true} hasBorderRadius={true} style={{ width: '100%' }}>
          <SubHeading style={{ marginTop: 0 }}>Furnishing</SubHeading>

          <SubHeading style={{ marginTop: 15 }}>Is this property furnished?</SubHeading>

          <Select
            value={fieldsValue?.furnished_type}
            style={{ width: '50%', height: '40px', borderWidth: 0 }}
            onChange={handleChange}
            variant="outlined"
            name="furnished_type"
            placeholder="Furnishing"
          >
            <MenuItem value={'Furnished'}>Furnished</MenuItem>
            <MenuItem value={'Part furnished'}>Part Furnished</MenuItem>
            <MenuItem value={'UnFurnished'}>UnFurnished</MenuItem>
          </Select>
        </CardBox>

        <Heading style={{ color: variables.purple, marginTop: '4%' }}>Number of Occupants</Heading>

        <CardBox hasShadow={true} hasBorderRadius={true} style={{ width: '100%' }}>
          <TextInput
            title={'Number of Occupants'}
            isfullwidth={true}
            value={fieldsValue?.number_of_occupants || ''}
            wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '49%', marginBottom: 15 }}
            onChange={handleChange}
            name="number_of_occupants"
            error={false}
          />
        </CardBox>

        <DepositSchemeSelector
          data={tdsArry}
          initialSelectedId={selectedTds}
          onSelect={(id) => setSelectedTds(id)}
        />
        <TouchableOpacity
          onPress={() => {
            _onAddRentalData(null, { send_to_tenant: true, resetRequest: true })
          }}
          style={{
            backgroundColor: '#9b5de5',
            paddingHorizontal: 30,
            paddingVertical: 14,
            borderRadius: 20,
            alignSelf: 'flex-end',
            marginTop: 10
          }}>
          <Text style={{
            color: 'white',
            fontWeight: '600',
          }}>Save</Text>
        </TouchableOpacity>
        {teanats && teanats.length > 0 ?
          <RentalStatusTable
            buttonText={showUpdateRentalOfferModal ? (global_state?.is_renewed ? "Resend Renewal offer" : "Resend Rental offer") : (global_state?.is_renewed ? 'Send Renewal Offer' : 'Send Rental Offer')}
            is_renewed={global_state?.is_renewed}
            onRightClick={() => { setSuccessModal(true) }}
            ten={teanats} flowId={flowId} /> : null}

        {rental_offers_data?.open_flow_rental_offer_id ? (
          <DraftAgreementStatusCard
            tenants={teanats}
            openFlow={global_state}
          />
        ) : null}
        <CardFooter>




        </CardFooter>
      </CardWrapper>
      <div>
        <Dialog
          open={showSuccessModal}
          onClose={() => {
            setSuccessModal(false)
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>

          {showUpdateRentalOfferModal ?
            <DialogContent>
              <DialogContentText sx={{ marginBottom: 10 }}>
                Are you sure, You want to update {global_state?.is_renewed ? 'renewal' : 'rental'} offer?.
              </DialogContentText>
              <DialogContentText>
                Upon updating <b>{global_state?.is_renewed ? 'Renewal' : 'Rental'} offer</b>, <b>holding deposit</b> and <b>move in monies</b> status will be reset.
              </DialogContentText>
            </DialogContent> :
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure, You want to send {global_state?.is_renewed ? 'renewal' : 'rental'} offer?
              </DialogContentText>
            </DialogContent>}
          <DialogActions>
            <DialogButton onClick={() => {
              TenantService.sendRentalOffer({
                flow_id: flowId,
                open_flow_sub_tenant_id: tenants.map((tenant) => tenant.open_flow_sub_tenant_id)
              }).then((response) => {
                fetchData()
                console.log("sendRentalOffer,", response)
                setSuccessModal(false)
                showSuccesToast("Offer Sent to all Tenants!")
              });


            }} color="primary">
              Ok
            </DialogButton>
            <DialogButton onClick={() => {
              setSuccessModal(false)

            }} color="secondary">
              Cancel
            </DialogButton>
          </DialogActions>
        </Dialog>
      </div>

    </Container>
  );
};
export default drawerHoc({
  Component: RentalOffers,
  showBackButton: true,
  backNavigation: "CurrentOnboards"
});
